export const environment = {
  name: "dev",
  production: false,
  instrumentationKey: "",
  baseUrl: "https://wellsh-dev.azure.chevron.com/",
  apiUrl: "https://wellsh-middleware-dev.azure.chevron.com",
  outboundApiUrl: "https://wellsh-wellview-outbound-dev.azure.chevron.com",
};